import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from 'components/Utils/FontAwesomeIconWrapper';
import { faEye } from '@fortawesome/pro-light-svg-icons';

// Badge « Lecture seule » discret et cohérent (portfolio + détail projet).
// Pill gris doux, arrondi, sans bordure — volontairement sobre.
export const ReadOnlyBadge = ({ className = '' }: { className?: string }) => {
	const { t } = useTranslation();
	return (
		<span
			className={className}
			style={{
				display: 'inline-flex',
				alignItems: 'center',
				gap: 6,
				padding: '2px 10px',
				borderRadius: 999,
				background: 'rgba(0, 0, 0, 0.045)',
				color: '#6b7280',
				fontSize: 12,
				fontWeight: 500,
				whiteSpace: 'nowrap',
				lineHeight: '18px'
			}}
		>
			{/* @ts-ignore */}
			<FontAwesomeIcon icon={faEye} />
			{t('pages.project.read_only_badge', { defaultValue: 'Lecture seule' })}
		</span>
	);
};

export default ReadOnlyBadge;
